import React, { Component, Fragment } from 'react'
import { Div, P, H3 } from '@drifthq/tide-core'
import NewAccount from 'images/newaccount.svg'
import FindTeam from 'images/findteam.svg'
import cx from 'classnames'
import { track } from 'utils/trackingUtils'
import './styles.css'

const GetStartedOption = ({ type, title, subtitle, history, path, icon, select, unselect, isActive }) => {
  return (
    <Div className={cx("get-started-option", {"selected" : isActive})}
      onMouseDown={() => select(type)}
      onMouseUp={unselect}
      onClick={() => {
          history.push(path)
          track(`${type} selected from Get Started Page`)
        }
      }
    >
      <Div className={cx("option-icon", type)}>
        <img alt="" src={icon}/>
      </Div>
      <Div className="option-info">
        <H3 className="option-title">{title}</H3>
        <P className="option-subtitle">{subtitle}</P>
      </Div>
    </Div>
  )
}

class GetStartedCard extends Component {
  state = {
    selected: null
  }

  selectOption = (selected) => {
    this.setState({selected})
  }

  unselect = () => {
    this.setState({selected: null})
  }

  get newSelected() {
    return this.state.selected === "new"
  }

  get existingSelected() {
    return this.state.selected === "existing"
  }

  render(){
    const { history } = this.props
    return (
      <Fragment>
        <h1 className="touchless-start-header get-started">Get started with Drift</h1>
        <P className="get-started-info">
          Drift loves helping teams succeed. You can join your teammates in your
          company's organization or create your own!
        </P>
        <GetStartedOption
          type={"new"}
          title={"Create a new Drift account"}
          subtitle={"Get your organization on Drift"}
          path={"/start/select"}
          history={history}
          icon={NewAccount}
          select={this.selectOption}
          unselect={this.unselect}
          isActive={this.newSelected}
        />
        <GetStartedOption
          type={"existing"}
          title={"Find your Drift organization"}
          subtitle={"Join an existing organization"}
          path={"/start/findTeam/verify"}
          history={history}
          icon={FindTeam}
          select={this.selectOption}
          unselect={this.unselect}
          isActive={this.existingSelected}
        />
      </Fragment>
    )
  }
}

export default GetStartedCard



// WEBPACK FOOTER //
// ./src/components/GetStartedCard/index.js